import React from "react";
import { MapPin, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="mt-24 border-t border-border bg-primary text-primary-foreground">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <div className="relative w-14 h-14 rounded-full overflow-hidden ring-1 ring-white/30 shadow-[0_6px_20px_-8px_rgba(0,0,0,0.5)] bg-white">
                            <img
                                src="/logo-circle.webp"
                                alt="Islamic Center of Federal Way"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <div>
                            <div className="font-serif text-xl">Islamic Center of Federal Way</div>
                            <div className="overline opacity-80">WEEKEND ISLAMIC SCHOOL</div>
                        </div>
                    </div>
                    <p className="mt-6 max-w-md opacity-85 leading-relaxed">
                        Nurturing the next generation with Quran, character, and community — every Sunday, for every family.
                    </p>
                </div>
                <div>
                    <div className="overline mb-4 opacity-70">Visit</div>
                    <div className="space-y-3 text-sm opacity-90">
                        <div className="flex gap-2" data-testid="footer-address"><MapPin className="w-4 h-4 mt-0.5" /> 33400 8th Ave S, Federal Way, WA 98003</div>
                        <div className="flex gap-2" data-testid="footer-email"><Mail className="w-4 h-4 mt-0.5" /> icfwislamicschool@icfwis.com</div>
                    </div>
                </div>
                <div>
                    <div className="overline mb-4 opacity-70">School Hours</div>
                    <div className="space-y-2 text-sm opacity-90">
                        <div>Sundays 10:00 AM – 1:40 PM</div>
                        <div>Grades Pre-K – 12</div>
                        <div>Quran & Arabic tracks</div>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs opacity-70 flex flex-wrap justify-between gap-4">
                    <div>© {new Date().getFullYear()} Islamic Center of Federal Way. All rights reserved.</div>
                    <div>Made with intention for our ummah.</div>
                </div>
            </div>
        </footer>
    );
}
